module.exports = __webpack_public_path__ + "img/anvil_white_logo.a58219b8.png";